import styled, { RuleSet } from "styled-components";
import React, { FC, ReactNode } from "react";
import { HStack } from "shared/components/Spor";

const Widget = styled.div<{ $widgetStyle?: RuleSet<object> }>`
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow-x: hidden;
  overflow-y: auto;
  &&& {
    ${({ $widgetStyle }) => $widgetStyle};
  }
`;

const WidgetHeader = styled.div`
  padding-bottom: 6px;
`;

const WidgetBody = styled.div`
  padding-top: 6px;
`;

const WidgetHeaderText = styled.div`
  font-size: 21px;
  font-weight: bold;

  * {
    font-size: 21px !important;
    font-weight: bold !important;
  }
`;

type Props = {
  headingLeft?: ReactNode;
  headingRight?: ReactNode;
  itemsLeft?: ReactNode;
  itemsRight?: ReactNode;
  children?: ReactNode;
  panelStyle?: RuleSet<object>;
} & React.HTMLAttributes<HTMLDivElement>;

export const SimpleHeadedWidget: FC<Props> = ({
  headingRight,
  headingLeft,
  itemsRight,
  itemsLeft,
  children,
  panelStyle,
  ...rest
}) => (
  <Widget $widgetStyle={panelStyle} {...rest}>
    <WidgetHeader>
      <HStack justify="space-between">
        <WidgetHeaderText>{headingLeft}</WidgetHeaderText>
        <HStack justify="flex-end">{headingRight}</HStack>
      </HStack>
    </WidgetHeader>

    <WidgetBody>
      <HStack justify="space-between">
        {itemsLeft}
        <HStack justify="flex-end">{itemsRight}</HStack>
      </HStack>
      {children}
    </WidgetBody>
  </Widget>
);
